'use client';

import 'swiper/css';

import { Swiper, SwiperSlide } from 'swiper/react';

import TabFilterItem from '@/app/(football)/[team]/_components/common/TabFilterItem';

interface CategoryFilterProps {
  categories: string[];
  selected: string;
  onSelect: (category: string) => void;
}

export default function CategoryFilter({ categories, selected, onSelect }: CategoryFilterProps) {
  return (
    <div className="relative flex-1 overflow-hidden">
      <Swiper slidesPerView="auto" spaceBetween={12} className="w-full">
        {categories.map((category) => (
          <SwiperSlide key={category} style={{ width: 'auto' }}>
            <TabFilterItem label={category} isSelected={selected === category} onClick={() => onSelect(category)} />
          </SwiperSlide>
        ))}
      </Swiper>
      {/* Right gradient overlay */}
      <div
        className="pointer-events-none absolute top-0 right-0 z-10 h-full w-[40px]"
        style={{
          background: 'linear-gradient(to right, transparent, var(--color-card-deco-filter-fade))',
        }}
      />
    </div>
  );
}
